import BaseClass from "../../util/BaseClass";
import * as aiimUtil from "../util/aiimUtil";

export default class Dataset extends BaseClass {

  layer2D;
  layer3D;
  name;
  requiresFacilityMode = false;
  subLayer;
  type;
  url;

  checkFieldNameProperty(propertyName, fields) {
    try {
      const v = this[propertyName];
      if (typeof v === "string" && v.length > 0 && fields) {
        const v2 = aiimUtil.findFieldName(fields,v);
        if (v !== v2 && typeof v2 === "string" && v2.length > 0) {
          this[propertyName] = v2;
        }
      }
    } catch(ex) {
      console.error("Dataset.checkFieldNameProperty",ex);
    }
  }

  checkSchema() {
    return Promise.resolve();
  }

  isMapServiceBased() {
    return this.layer2D && !!this.subLayer;
  }

}
